/**
 * Estrae 1-3 stringhe distintive dal contenuto di un chunk per la ricerca
 * nel testo layer del PDF originale. Rimuove i prefissi aggiunti in
 * ingestion (descrizione tabella, keywords, header sezione/articolo) e
 * normalizza markdown table rows.
 *
 * Restituisce un array di candidati perche' il text layer di PDF.js non
 * matcha attraverso i line-break: il plugin search prova tutti i candidati
 * ed evidenzia quelli trovati.
 */
export function extractSearchableChunkText(content) {
    let body = content;

    // 1. Strip "[Descrizione tabella: ...]\n\n"
    body = body.replace(/^\[Descrizione tabella:[^\]]*\]\s*\n\n?/, "");

    // 2. Strip "[Keywords: ... ]\n\n" (multi-line)
    body = body.replace(/^\[Keywords:[\s\S]*?\]\s*\n\n?/, "");

    // 3. Strip header tipo "[Art. N - ...]" / "[Sezione X - ...]" / "[Allegato X - ...]" / "[CAPO ...]"
    body = body.replace(/^\[[^\]\n]+\]\s*\n\n?/, "");

    body = body.trim();
    if (!body) return [];

    const candidates = [];

    const rawLines = body
        .split("\n")
        .map((l) => l.trim())
        .filter(Boolean);

    // A. Prime 2 righe narrative (non markdown table, non separator), lunghezza >= 25
    const narrativeLines = rawLines.filter((l) => {
        if (l.startsWith("|")) return false;
        if (/^[-:|\s]+$/.test(l)) return false;
        return l.length >= 25;
    });

    if (narrativeLines.length > 0) {
        candidates.push(truncateForSearch(narrativeLines[0]));
        if (narrativeLines.length > 1) {
            const secondIdx = Math.min(2, narrativeLines.length - 1);
            candidates.push(truncateForSearch(narrativeLines[secondIdx]));
        }
    }

    // B. Estrai cella distintiva (la piu' lunga) da una data row di markdown table
    const dataRow = rawLines.find((l) => {
        if (!l.startsWith("|")) return false;
        if (/^\|[\s\-:|]+\|?$/.test(l)) return false; // separator row
        return l.split("|").length > 2;
    });

    if (dataRow) {
        const cells = dataRow
            .split("|")
            .map((c) => c.trim())
            .filter((c) => c.length >= 8 && !/^-+$/.test(c));
        if (cells.length > 0) {
            const longest = [...cells].sort((a, b) => b.length - a.length)[0];
            candidates.push(truncateForSearch(longest));
        }
    }

    // Dedupe + limit a 3
    return Array.from(new Set(candidates.filter((c) => c.length > 0))).slice(0, 3);
}

function truncateForSearch(s) {
    const cleaned = s
        .replace(/\*\*(.*?)\*\*/g, "$1")
        .replace(/(?<!\*)\*(?!\*)([^*\n]+?)\*/g, "$1")
        .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
        .replace(/\s+/g, " ")
        .trim();

    if (cleaned.length <= 100) return cleaned;
    const cut = cleaned.slice(0, 80);
    const lastSpace = cut.lastIndexOf(" ");
    return lastSpace > 40 ? cut.slice(0, lastSpace) : cut;
}
